import type { AxiosInstance } from 'axios';
import { PAYMENT_HISTORY_ENDPOINTS } from './endpoints';
import type { PaymentListApiResponse } from './types';

/** Parameters accepted by the payment history list endpoint. */
export type PaymentHistoryListParams = {
  blockUuid?: string;
  page: number;
  pageSize: number;
};

/** HTTP client type for payment history operations */
export type PaymentHistoryHttpClientType = {
  list: (params: PaymentHistoryListParams) => Promise<PaymentListApiResponse>;
};

/**
 * Creates the HTTP client for payment history API operations.
 *
 * Targets `GET /v1/payments` in parrot-subscriptions-api; org filtering is
 * derived from the JWT. Supports pagination via `page` and `pageSize` query
 * params and optional `block_uuid` to filter by subscription block.
 */
export const createPaymentHistoryHttpClient = (props: {
  httpClientSubscription: AxiosInstance;
}): PaymentHistoryHttpClientType => {
  const { httpClientSubscription } = props;

  const list = async (params: PaymentHistoryListParams): Promise<PaymentListApiResponse> => {
    const response = await httpClientSubscription.get<PaymentListApiResponse>(PAYMENT_HISTORY_ENDPOINTS.LIST, {
      params: {
        page: params.page,
        pageSize: params.pageSize,
        ...(params.blockUuid ? { block_uuid: params.blockUuid } : {}),
      },
    });
    return response.data;
  };

  return { list };
};
